// extracted by mini-css-extract-plugin
export default {"dashboardData":"Dashboard_dashboardData__Z86jB","data":"Dashboard_data__vJ0X7"};